import { createIconComponent } from './helpers';
import { faTimes } from '@fortawesome/free-solid-svg-icons'

export const XIcon = createIconComponent(faTimes);
